import {useCallback} from 'react';
import {useEventListener} from './useEventListener';

export interface UseFilePasteOptions {
  onFilePaste: (file: File) => void | Promise<void>;
}

/**
 * Hook to handle pasting files from clipboard
 * Sets up a global paste event listener that processes all file types
 */
export default function useFilePaste({onFilePaste}: UseFilePasteOptions) {
  const handlePaste = useCallback(
    async (e: ClipboardEvent) => {
      const items = e.clipboardData?.items;
      if (!items) return;

      Array.from(items).forEach(async (item) => {
        if (item.kind === 'file') {
          e.preventDefault();
          const file = item.getAsFile();
          if (file) {
            await onFilePaste(file);
          }
        }
      });
    },
    [onFilePaste],
  );

  useEventListener(document, 'paste', handlePaste);
}
